//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { AppMixin } from "~/node_modules/sitis-nuxt/lib/mixins";

export default {

  mixins: [
    AppMixin
  ],

  props: {
    open: {
      type: Boolean,
      default: false
    },
    services: {
      type: Array,
      default: () => {
        return []
      }
    },
    currentService:{
      type:Object,
      default:()=>({})
    },

    selectedAge: {
      type: String,
      default: ""
    },
    customMessage: {
      type: Boolean,
      default: false
    }
  },

  data: function(){
    return {
      yesAnswer: false
    }
  },

  computed: {
    message: function () {
      // return this.vars?.["popup-select-mkl__message"]
      return 'Вы уже умеете снимать и надевать контактные линзы?'
    },
    buttonSuccess: function () {
      return this.vars?.["popup-select-mkl__button-success"]
    },
    buttonCancen: function () {
      return this.vars?.["popup-select-mkl__button-cancel"]
    },
  },

  methods: {
    onSuccess: function () {
      let serviceId = 20;
      if (this.selectedAge === "2-6") {
        serviceId = 38;
      }
      if (this.selectedAge === "7-11") {
        serviceId = 39;
      }
      if (this.selectedAge === "12-18") {
        serviceId = 37;
      }

      this.$emit(
        "onSelect",
        this.services.find((t) => +t.id === serviceId)
      )

      this.$emit('onResetCustomMessage');
    },

    onSuccessWithCustomMessage: function () {
      let serviceId = 8;
      if (this.selectedAge === "2-6") {
        serviceId = 40;
      }
      if (this.selectedAge === "7-11") {
        serviceId = 42;
      }
      if (this.selectedAge === "12-18") {
        serviceId = 41;
      }

      this.$emit(
          "onSelect",
          this.services.find((t) => +t.id === serviceId)
      )
    },

    onCancel: function () {
      this.$emit(
        "onSelect",
        this.currentService
      )
      this.$emit('onResetCustomMessage');
    },


    onSubmit: function () {
      if(this.yesAnswer) {
        this.onCancel()
      }else {
        this.onSuccess()
      }
    },

    onClose: function () {
      this.$emit("onClose");
      this.$emit('onResetCustomMessage');
    },

    onChangeYesAnswer: function (bool) {
      this.yesAnswer = bool;
    }

  }

}
